/*
Notes: 可以在此修改项目部分设置
Date:2018/8/30 by Hgwn
*/
const ajaxBaseUrl = '/api'
export default {
  ajaxBaseUrl,
  companyName: {
    full: {
      eng: 'DeelonBaoli'.toUpperCase(),
      chn: '帝隆保理'
    },
    shortcut: {
      eng: 'DeelonBaoli',
      chn: '帝隆保理'
    }
  },
  tokenId:'dl_tokenId_bl',// 自定义tokenId  -- localhost 存储tokenId名称
  imageSrcPrefix: `${ajaxBaseUrl}/platform/system/sysFile/getFileById.ht?fileId=`,
  contractImageSrc: `${ajaxBaseUrl}/mobile/item/pdfSignatureController/readContract.ht?identify=`,
  contractImageSrcBl: `${ajaxBaseUrl}/mobile/item/pdfSignatureController/blReadContract.ht?identify=`
}



// WEBPACK FOOTER //
// ./src/config.js